<template>
  <div class="stream-item">
      <van-row gutter="20">
        <van-col span="6">
            <router-link ref="nofollow" :to="{path:'/details/',query:{apkpkg:item.apkpkg}}">
                <van-image
                radius="7"
                :src="item.apkicon"
                />
            </router-link>
        </van-col>
        <van-col span="12">
            <router-link ref="nofollow" :to="{path:'/details/',query:{apkpkg:item.apkpkg}}">
                <h3 class="gamename">{{item.apkname}}</h3>
                <p class="game-developer">Developer: {{ item.developerName }}</p>
                <div class="game-price">
                    <span class="price-old">{{ item.price_old }}</span>
                    <div class="game-discount">{{ item.discount }}</div>
                </div>
            </router-link>
        </van-col>
        <van-col span="6">
            <router-link ref="nofollow" :to="{path:'/details/',query:{apkpkg:item.apkpkg}}">
                <van-button type="default" :icon="down" class="detailbtn" size="small "> {{ item.price_new }} </van-button>
            </router-link>
        </van-col>
    </van-row>
  </div>
</template>
<script>
export default {
    props:{
        type: Object,
        item: {
            apkpkg:String,
        }
    },
    data() {
        return {
            down: 'https://cdn.hotplaydl.com/static/img/down.png'
        }
    },
    created() {

    }
}
</script>

<style scoped>
.stream-item {
    margin: 20px 0;
    /* border-bottom: 1px solid #ccc; */
}
.van-col {
    height: 100%;
}
.van-image {
    margin-top: 4px;
    width: 75%;
    border-radius: 8px;
}
.gamename {
    font-size: 14px;
    color: #2F3234;
    margin-top: 6px;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
}
.developer {
    font-size: 12px;
    line-height: 18px;
    color: #999999;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    display: block;
}
.star {
    text-align: left;
    line-height: 18px;
    margin-top: 6px;
}
.starnum {
    font-size: 12px;
    line-height:18px;
    color: #999999;
    vertical-align: top;
    margin-left:5px;
}
.detailbtn {
    width: 70px;
    height: 28px;
    background-color: #4A90E2;
    border-radius: 4px;
    font-size: 12px;
    color: white;
    line-height: 28px;
    margin-top: 50%;
    transform: translateY(-65%);
}
.van-button__icon {
    min-width: 0;
}
.van-button--small {
    min-width: 0;
    padding: 0;
}
.van-image__img {
    width: 12px;
    height: 12px;
}
.game-developer {
    font-size: 12px;
    font-family: Roboto-Regular,Roboto;
    font-weight: 400;
    color: rgba(153,153,153,1);
    text-align: left;
}
.game-price {
    text-align: left;
}
.price-old {
    display: inline-block;
    font-size: 12px;
    font-family: Roboto-Medium,Roboto;
    font-weight: 500;
    color: rgba(153,153,153,1);
    text-decoration: line-through;
}
.game-discount {
    display: inline-block;
    background: rgba(25,192,136,1);
    border-radius: 0 4px 4px 0;
    font-size: 12px;
    font-family: Roboto-Medium,Roboto;
    font-weight: 500;
    color: rgba(255,255,255,1);
    margin-left: 10px;
    position: relative;
    padding: 0 5px;
    height: 15px;
    line-height: 18px;
}
.game-discount::before {
  background: #19C088;
  border-top: 1px solid #19C088;
  border-left: 1px solid #19C088;
  border-right: 0;
  content: "";
  position: absolute;
  transform: rotate(225deg);
  width: 9px;
  height: 9px;
  left: -5px;
  top: 2.4px;
  z-index: -1;
}
</style>


// WEBPACK FOOTER //
// src/components/saleGame.vue